import { jsx as _jsx } from "react/jsx-runtime";
import { Fingerprint } from 'lucide-react';
import { useSearch } from '@tanstack/react-router';
import { IdentityHistory } from './routes/history.js';
import { IdentityTest } from './routes/test.js';
/**
 * Index route. Disambiguates by search param so a single route serves both
 * surfaces without a dead-end:
 *   - `?conversationId=…` / `?contactId=…` (deep-linked from the contact rail)
 *     → the read-only resolution history for that subject.
 *   - no scope param (the sidebar entry lands here) → the "Тест идентификации"
 *     probe tool.
 */
function IdentityIndex() {
    const search = useSearch({ strict: false });
    if (search.conversationId || search.contactId)
        return _jsx(IdentityHistory, {});
    return _jsx(IdentityTest, {});
}
export const identityModule = {
    id: 'identity',
    label: 'Идентификация',
    icon: Fingerprint,
    permission: 'identity.read',
    workspace: 'support',
    order: 91,
    description: 'Тест идентификации WIT — проверка email по сервису и журнал прошлых поисков (из карточки контакта).',
    // Sidebar entry lands on the test tool; the resolution history is still
    // deep-linked from the contact rail via a conversationId/contactId param.
    showInNav: true,
    routes: [{ path: '/', component: IdentityIndex }],
};
export { IdentityHistory } from './routes/history.js';
export { IdentityTest } from './routes/test.js';
export { setIdentityApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map